import { Check, X } from "lucide-react";

import { ColocaBadge } from "@/shared/components/data-display/ColocaBadge";
import { useTranslations } from "@/shared/lang/useTranslations";

import type { PolicyEffect } from "../../types/access.types";

export interface AccessEffectBadgeProps {
  effect: PolicyEffect;
}

/** ALLOW (primary) / DENY (destructive) badge for policies. */
export function AccessEffectBadge({ effect }: AccessEffectBadgeProps) {
  const { t } = useTranslations("settings");
  return effect === "deny" ? (
    <ColocaBadge variant="destructive" icon={X}>
      {t("access_policy_effect_deny")}
    </ColocaBadge>
  ) : (
    <ColocaBadge variant="primary" icon={Check}>
      {t("access_policy_effect_allow")}
    </ColocaBadge>
  );
}
